// extracted by mini-css-extract-plugin
module.exports = {"row":"TermsAdminScreen_row__3VDfJ"};